import React, { FC } from 'react';

import { Box, HStack } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import { FilterLabelWrapper } from 'components/DataDisplay/Box/BorderedBox/FilterLabelWrapper';
import { Select } from 'components/DataEntry';
import { SearchBox } from 'components/DataEntry/Input/SearchBox';
import { fixPlanSourceOptions } from 'containers/Visibility/Vulnerabilities/Components/ResourceVulnerabilities/utils';
import {
  exploitableOptions,
  patchAvailableOptions,
  vulnerabilitySeverityOptions,
} from 'containers/Visibility/Vulnerabilities/Components/utils';
import { selectVulnerabilities } from 'containers/Visibility/Vulnerabilities/selectors';

interface Props {
  severity?: Record<string, any>;
  publishedAt?: Record<string, any>;
  isPatchable?: Record<string, any>;
  source?: Record<string, any>;
  hasPublicExploit?: Record<string, any>;
  vulnerabilityType?: string;
  updateValue: (field: string, value: any) => void;
  searchTerm?: string;
  tab?: string;
}

export const ResourceVulnerabilitiesFilters: FC<Props> = props => {
  const {
    severity,
    publishedAt,
    isPatchable,
    source,
    vulnerabilityType,
    hasPublicExploit,
    searchTerm,
    updateValue,
    tab,
  } = props;
  const { resourceInsight } = useSelector(selectVulnerabilities);
  const { isLoading } = resourceInsight;

  return (
    <HStack>
      {tab !== 'fix-plan' && (
        <Box w={72}>
          <SearchBox
            value={searchTerm}
            onChange={s => updateValue('searchTerm', s)}
            onSearch={() => updateValue('finalSearchTerm', searchTerm)}
            placeholder="Search"
            isDisabled
          />
        </Box>
      )}
      <FilterLabelWrapper>FILTER BY</FilterLabelWrapper>
      {tab !== 'fix-plan' && (
        <Box>
          <Select
            isAFilter
            options={vulnerabilitySeverityOptions}
            value={severity}
            onChange={v => updateValue('severity', v)}
            isDisabled={isLoading}
            menuPortalTarget={document.body}
            showUndefinedValueLabel={false}
            leftMessage="Severity"
          />
        </Box>
      )}
      <Box>
        <Select
          isAFilter
          options={exploitableOptions}
          value={hasPublicExploit}
          onChange={v => updateValue('hasPublicExploit', v)}
          showIconInValueContainer
          leftMessage="Has Public Exploit"
          //isDisabled={isLoading}
          menuPortalTarget={document.body}
          showUndefinedValueLabel={false}
          isDisabled={tab !== 'fix-plan'}
        />
      </Box>
      {tab === 'fix-plan' && (
        <Box>
          <Select
            isAFilter
            options={fixPlanSourceOptions}
            value={source}
            onChange={v => updateValue('source', v)}
            showIconInValueContainer
            leftMessage="Source"
            isDisabled={isLoading}
            menuPortalTarget={document.body}
            showUndefinedValueLabel={false}
          />
        </Box>
      )}
      {tab !== 'fix-plan' && (
        <Box>
          <Select
            isAFilter
            options={patchAvailableOptions}
            value={isPatchable}
            onChange={v => updateValue('isPatchable', v)}
            showIconInValueContainer
            leftMessage="Has Patch"
            isDisabled={isLoading}
            menuPortalTarget={document.body}
            showUndefinedValueLabel={false}
          />
        </Box>
      )}
      {/*<SelectHistoricalOptions
        historicalTime={publishedAt}
        setHistoricalTime={v => updateValue('publishedAt', v)}
        leftMessage={
          vulnerabilityType === 'resolved' ? 'Resolved' : 'Published'
        }
        isAFilter
      />*/}
      {/*<Box pl={4} pr={2}>
        <FilterLabelWrapper>LIST</FilterLabelWrapper>
      </Box>
      <RadioGroup
        value={vulnerabilityType}
        onChange={v => updateValue('vulnerabilityType', v)}
      >
        <HStack>
          {map(vulnerabilityTypeItems, o => (
            <Radio value={o.value}>{o.label}</Radio>
          ))}
        </HStack>
      </RadioGroup>*/}
    </HStack>
  );
};
